import React, {useEffect, useState} from 'react'

import { addDays } from 'date-fns';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import DateRangePicker from "react-date-range/dist/components/DateRangePicker";
import {changeFilter} from "../../../actions/pages";
import {requestPageComments} from "../../../actions/requests";
import {useDispatch, useSelector} from "react-redux";
import { timeFormat } from 'd3-time-format'
import {defaultStaticRanges} from "../../../constants";

const DateRangeWrapper = ({startDate, endDate}) => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const {profile, account_level} = user
    const {data_retention} = account_level.attributes
    const {week_starts_on} = profile.attributes
    const [newStartDate, setNewStartDate] = useState("")
    const [newEndDate, setNewEndDate] = useState("")
    const [staticRange, setStaticRange] = useState(false)
    const formatter_submit = timeFormat('%d-%m-%Y')

    const handleStaticRange = () => {
        setStaticRange(true)
    }

    const handleSelect = (date) => {
        setState([date.selection])
        if(date.selection.startDate.getTime()!==date.selection.endDate.setHours(0, 0, 0, 0)){
            setNewEndDate(date.selection.endDate)
        }else{
            if(newStartDate !== "" || staticRange){
                setNewEndDate(date.selection.endDate)
            }else{
                setNewEndDate("")
            }
        }
        setNewStartDate(date.selection.startDate)
        staticRange && setStaticRange(false)
    }

    useEffect(()=>{
        if(newEndDate!=="")
        {
            dispatch(changeFilter("startDate", formatter_submit(newStartDate)))
            if(newStartDate.getTime() !== newEndDate.getTime()){
                dispatch(changeFilter("endDate", formatter_submit(newEndDate)))
            }else{
                dispatch(changeFilter("endDate", ""))
            }
            dispatch(requestPageComments())
            setNewStartDate("")
            setNewEndDate("")
        }

    },[newEndDate])


    useEffect(()=>{
        const divs = document.querySelectorAll('.rdrStaticRange');
        divs.forEach(el => el.addEventListener('click', handleStaticRange));
        return () => {
            divs.forEach(el => el.removeEventListener('click', handleStaticRange));
        }
    },[])

    const [state, setState] = useState([
        {
            startDate: startDate || new Date(),
            endDate: endDate || startDate || new Date(),
            key: 'selection'
        }
    ]);

    return (
        <div>
            <DateRangePicker
                onChange={handleSelect}
                showDateDisplay={false}
                editableDateInputs={false}
                rangeColors={['#2bae76']}
                showMonthAndYearPickers={false}
                maxDate={new Date()}
                minDate={addDays(new Date(), -data_retention)}
                inputRanges={[]}
                weekStartsOn={week_starts_on}
                ranges={state}
                staticRanges={defaultStaticRanges(week_starts_on)}
            />
        </div>
    )
}

export default React.memo(DateRangeWrapper)